import type { Unsubscribe } from './observable';

/**
 * Abstraction over a frame-driving clock (DIP). Lets the engine depend on
 * "something that ticks" rather than on requestAnimationFrame directly,
 * which makes it trivially testable with a fake clock.
 */
export interface IClock {
  /** Current time in ms. */
  now(): number;
  /** Run `frame` on every animation frame until unsubscribed. */
  onFrame(frame: () => void): Unsubscribe;
}

/** Production clock backed by requestAnimationFrame. */
export class RafClock implements IClock {
  now(): number {
    return Date.now();
  }

  onFrame(frame: () => void): Unsubscribe {
    let rafId = 0;
    const loop = () => {
      frame();
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafId);
  }
}
